import request from '@/utils/request' //引入封装好的 axios 请求

export function updateProduct(product) { //添加接口

  return request({ //使用封装好的 axios 进行网络请求
    url: '/product/updateProduct',
    method: 'post',
    data: {
      productId: product.productId,
      //标题
      productName: product.productName,
      //描述
      productDesc:product.productDesc,
      //缩略图
      photo: product.photo,
      //产品内容
      productContent:product.productContent,
      //修改时间
      updateTime: product.updateTime,
      //类型
      type:product.type
    },
  })
}

export function updateProductReleaseKbn(productId,releaseKbn,updateTime) {
  return request({
    url: '/product/updateProductReleaseKbn',
    method: 'post',
    data: {
      productId,
      releaseKbn,
      updateTime
    }

  })
}

export function UpdateProductType (pType) {
  return request({
    url: '/product/UpdateProductType',
    method: 'post',
    data: {
      typeName: pType.typeName,
      note: pType.note,
      typeId: pType.typeId
    }
  })
}